// ===================================
// KAIXO - Países y sus regiones/estados/departamentos
// Cada país se muestra en su idioma nativo, ordenado alfabéticamente.
// ===================================

// Lista de países: cada entrada tiene el nombre nativo (lo que se muestra)
// y el nombre en español (clave para REGIONS_BY_COUNTRY por retrocompat).
export const COUNTRIES_RAW = [
    { id: 'España',                  native: 'España' },
    { id: 'México',                  native: 'México' },
    { id: 'Argentina',               native: 'Argentina' },
    { id: 'Colombia',                native: 'Colombia' },
    { id: 'Chile',                   native: 'Chile' },
    { id: 'Perú',                    native: 'Perú' },
    { id: 'Venezuela',               native: 'Venezuela' },
    { id: 'Ecuador',                 native: 'Ecuador' },
    { id: 'Bolivia',                 native: 'Bolivia' },
    { id: 'Paraguay',                native: 'Paraguay' },
    { id: 'Uruguay',                 native: 'Uruguay' },
    { id: 'Cuba',                    native: 'Cuba' },
    { id: 'República Dominicana',    native: 'República Dominicana' },
    { id: 'Puerto Rico',             native: 'Puerto Rico' },
    { id: 'Guatemala',               native: 'Guatemala' },
    { id: 'Honduras',                native: 'Honduras' },
    { id: 'El Salvador',             native: 'El Salvador' },
    { id: 'Nicaragua',               native: 'Nicaragua' },
    { id: 'Costa Rica',              native: 'Costa Rica' },
    { id: 'Panamá',                  native: 'Panamá' },
    // Portugal / Brasil
    { id: 'Portugal',                native: 'Portugal' },
    { id: 'Brasil',                  native: 'Brasil' },
    // EU
    { id: 'Alemania',                native: 'Deutschland' },
    { id: 'Austria',                 native: 'Österreich' },
    { id: 'Bélgica',                 native: 'België / Belgique' },
    { id: 'Francia',                 native: 'France' },
    { id: 'Italia',                  native: 'Italia' },
    { id: 'Holanda',                 native: 'Nederland' },
    { id: 'Reino Unido',             native: 'United Kingdom' },
    { id: 'Irlanda',                 native: 'Éire / Ireland' },
    { id: 'Suiza',                   native: 'Schweiz / Suisse' },
    { id: 'Polonia',                 native: 'Polska' },
    { id: 'Suecia',                  native: 'Sverige' },
    { id: 'Noruega',                 native: 'Norge' },
    { id: 'Dinamarca',               native: 'Danmark' },
    { id: 'Finlandia',               native: 'Suomi' },
    { id: 'Grecia',                  native: 'Ελλάδα' },
    { id: 'Turquía',                 native: 'Türkiye' },
    { id: 'Rusia',                   native: 'Россия' },
    // Americas (anglo)
    { id: 'Estados Unidos',          native: 'United States' },
    { id: 'Canadá',                  native: 'Canada' },
    // Oceania
    { id: 'Australia',               native: 'Australia' },
    { id: 'Nueva Zelanda',           native: 'New Zealand' },
    // Asia
    { id: 'Japón',                   native: '日本' },
    { id: 'China',                   native: '中国' },
    { id: 'Corea del Sur',           native: '대한민국' },
    { id: 'India',                   native: 'भारत' },
    { id: 'Indonesia',               native: 'Indonesia' },
    // Middle East / Africa
    { id: 'Arabia Saudita',          native: 'المملكة العربية السعودية' },
    { id: 'Emiratos Árabes Unidos',  native: 'الإمارات العربية المتحدة' },
    { id: 'Egipto',                  native: 'مصر' },
    { id: 'Marruecos',               native: 'المغرب' },
    { id: 'Sudáfrica',               native: 'South Africa' }
];

// Ordenar alfabéticamente por nombre nativo (localeCompare respeta acentos/unicode)
export const COUNTRIES_LIST = [...COUNTRIES_RAW].sort((a, b) =>
    a.native.localeCompare(b.native, undefined, { sensitivity: 'base' })
);

// Compat: lista plana con el `id` (que es el nombre en español, usado como
// clave en REGIONS_BY_COUNTRY y en los documentos persistidos)
export const COUNTRIES = COUNTRIES_LIST.map(c => c.id);

// Helper para obtener el nombre nativo a partir del id
export function nativeName(countryId) {
    const c = COUNTRIES_RAW.find(x => x.id === countryId);
    return c?.native || countryId;
}

export const REGIONS_BY_COUNTRY = {
    'España': [
        'Andalucía', 'Aragón', 'Asturias', 'Baleares', 'Canarias', 'Cantabria',
        'Castilla-La Mancha', 'Castilla y León', 'Catalunya', 'Ceuta', 'Extremadura',
        'Galicia', 'La Rioja', 'Madrid', 'Melilla', 'Murcia', 'Navarra',
        'País Vasco', 'Valencia'
    ],
    'México': [
        'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
        'Chiapas', 'Chihuahua', 'CDMX', 'Coahuila', 'Colima', 'Durango',
        'Estado de México', 'Guanajuato', 'Guerrero', 'Hidalgo', 'Jalisco',
        'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León', 'Oaxaca', 'Puebla',
        'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora',
        'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
    ],
    'Argentina': [
        'Buenos Aires', 'CABA', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba',
        'Corrientes', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa', 'La Rioja',
        'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta', 'San Juan',
        'San Luis', 'Santa Cruz', 'Santa Fe', 'Santiago del Estero',
        'Tierra del Fuego', 'Tucumán'
    ],
    'Colombia': [
        'Amazonas', 'Antioquia', 'Arauca', 'Atlántico', 'Bogotá', 'Bolívar',
        'Boyacá', 'Caldas', 'Caquetá', 'Casanare', 'Cauca', 'Cesar', 'Chocó',
        'Córdoba', 'Cundinamarca', 'Guainía', 'Guaviare', 'Huila', 'La Guajira',
        'Magdalena', 'Meta', 'Nariño', 'Norte de Santander', 'Putumayo',
        'Quindío', 'Risaralda', 'San Andrés', 'Santander', 'Sucre', 'Tolima',
        'Valle del Cauca', 'Vaupés', 'Vichada'
    ],
    'Chile': [
        'Arica y Parinacota', 'Tarapacá', 'Antofagasta', 'Atacama', 'Coquimbo',
        'Valparaíso', 'Metropolitana', 'O\'Higgins', 'Maule', 'Ñuble', 'Biobío',
        'Araucanía', 'Los Ríos', 'Los Lagos', 'Aysén', 'Magallanes'
    ],
    'Perú': [
        'Amazonas', 'Áncash', 'Apurímac', 'Arequipa', 'Ayacucho', 'Cajamarca',
        'Callao', 'Cusco', 'Huancavelica', 'Huánuco', 'Ica', 'Junín',
        'La Libertad', 'Lambayeque', 'Lima', 'Loreto', 'Madre de Dios',
        'Moquegua', 'Pasco', 'Piura', 'Puno', 'San Martín', 'Tacna', 'Tumbes',
        'Ucayali'
    ],
    'Venezuela': [
        'Amazonas', 'Anzoátegui', 'Apure', 'Aragua', 'Barinas', 'Bolívar',
        'Carabobo', 'Cojedes', 'Delta Amacuro', 'Distrito Capital', 'Falcón',
        'Guárico', 'Lara', 'Mérida', 'Miranda', 'Monagas', 'Nueva Esparta',
        'Portuguesa', 'Sucre', 'Táchira', 'Trujillo', 'Vargas', 'Yaracuy', 'Zulia'
    ],
    'Estados Unidos': [
        'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
        'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho',
        'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
        'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
        'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
        'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina',
        'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
        'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas',
        'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin',
        'Wyoming'
    ],
    'Brasil': [
        'Acre', 'Alagoas', 'Amapá', 'Amazonas', 'Bahía', 'Ceará', 'Distrito Federal',
        'Espírito Santo', 'Goiás', 'Maranhão', 'Mato Grosso', 'Mato Grosso do Sul',
        'Minas Gerais', 'Pará', 'Paraíba', 'Paraná', 'Pernambuco', 'Piauí',
        'Río de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondônia',
        'Roraima', 'Santa Catarina', 'São Paulo', 'Sergipe', 'Tocantins'
    ],
    'Francia': [
        'Auvergne-Rhône-Alpes', 'Borgoña-Franco Condado', 'Bretaña',
        'Centro-Valle de Loira', 'Córcega', 'Gran Este', 'Altos de Francia',
        'Isla de Francia', 'Normandía', 'Nueva Aquitania', 'Occitania',
        'País del Loira', 'Provenza-Alpes-Costa Azul'
    ],
    'Alemania': [
        'Baden-Württemberg', 'Baviera', 'Berlín', 'Brandeburgo', 'Bremen',
        'Hamburgo', 'Hesse', 'Mecklemburgo-Pomerania Occidental', 'Baja Sajonia',
        'Renania del Norte-Westfalia', 'Renania-Palatinado', 'Sarre', 'Sajonia',
        'Sajonia-Anhalt', 'Schleswig-Holstein', 'Turingia'
    ],
    'Italia': [
        'Abruzos', 'Basilicata', 'Calabria', 'Campania', 'Emilia-Romaña',
        'Friuli-Venecia Julia', 'Lacio', 'Liguria', 'Lombardía', 'Marcas',
        'Molise', 'Piamonte', 'Apulia', 'Cerdeña', 'Sicilia', 'Toscana',
        'Trentino-Alto Adigio', 'Umbría', 'Valle de Aosta', 'Véneto'
    ],
    'Portugal': [
        'Aveiro', 'Beja', 'Braga', 'Bragança', 'Castelo Branco', 'Coímbra',
        'Évora', 'Faro', 'Guarda', 'Leiría', 'Lisboa', 'Portalegre', 'Oporto',
        'Santarém', 'Setúbal', 'Viana do Castelo', 'Vila Real', 'Viseu',
        'Azores', 'Madeira'
    ],
    'Reino Unido': [
        'Inglaterra', 'Escocia', 'Gales', 'Irlanda del Norte'
    ],
    'Canadá': [
        'Alberta', 'Columbia Británica', 'Manitoba', 'Nuevo Brunswick',
        'Terranova y Labrador', 'Nueva Escocia', 'Ontario', 'Isla del Príncipe Eduardo',
        'Quebec', 'Saskatchewan', 'Territorios del Noroeste', 'Nunavut', 'Yukón'
    ]
};

export function getRegionsForCountry(country) {
    return REGIONS_BY_COUNTRY[country] || [];
}
